<template>
  <button type="button" :disabled="!condition" class='btn btn-outline-secondary  btn-sm' @click="click">
    <span v-bind:class="templateArgs.data.icon"></span>
    {{templateArgs.data.text}}
  </button>
</template>

<script>
  export default {
    data() {
      return {
        templateArgs: {},
        itemText: 'template'
      }
    },
    computed: {
      condition() {
        if(typeof this.templateArgs.data.condition === 'function')
          return this.templateArgs.data.condition(this.templateArgs)

        return true
      }
    },
    methods: {
      click(e) {
        this.templateArgs.data.click(e, this.templateArgs)
      }
    }
  };
</script>
